import React from 'react'
import classNames from 'classnames'
import './index.css'
import useIsMediumScreen from 'hooks/use-is-medium-screen'
import Flex from 'components/Flex'
import H1 from 'components/H1'
import ButtonLink from 'components/ButtonLink'
import { ROUTE_PATH } from 'modules/route/constants'
import P from 'components/P'
import logEventAnalyticsUtil from 'utils/analytics/log-event'
import Link from 'components/Link'
import SquadMembersImage from 'pages/Squad/components/MembersImage'
import removeMainContentPaddingDomUtil from 'utils/dom/remove-main-content-padding'
import SquadPageEmptyHowItWorks from 'pages/Squad/components/Empty/HowItWorks'
import setShouldScrollToReferAFriendAfterSignInUtil from 'pages/Squad/utils/set-scroll-to-refer-a-friend-after-sign-in'

const TITLE = 'Introducing my squad'
const DESCRIPTION = 'Discover the latest beauty trends loved by your squad. Rate a product and let your friends in on the secret!'
const JOIN_NOW = 'Join now'
const SIGN_IN = 'Sign in'

const ANALYTICS_EVENT = {
  SQUAD_EMPTY_JOIN_NOW: 'SQUAD_EMPTY_JOIN_NOW',
  SQUAD_EMPTY_SIGN_IN: 'SQUAD_EMPTY_SIGN_IN'
}
export default function SquadPageEmpty () {
  const isMediumScreen = useIsMediumScreen()
  const debugProps = {
    isMediumScreen
  }
  logUtil('SquadPageEmpty').debug('[start] debugProps=', debugProps)

  const handleJoinNow = () => {
    logEventAnalyticsUtil(ANALYTICS_EVENT.SQUAD_EMPTY_JOIN_NOW)
    setShouldScrollToReferAFriendAfterSignInUtil()
  }
  const handleClickSignIn = () => {
    logEventAnalyticsUtil(ANALYTICS_EVENT.SQUAD_EMPTY_SIGN_IN)
    setShouldScrollToReferAFriendAfterSignInUtil()
  }

  React.useEffect(() => {
    removeMainContentPaddingDomUtil()
  }, [])

  return (
    <Flex className={classNames({ 'squad-empty': true })}>
      <SquadMembersImage />
      <H1>{TITLE}</H1>
      <P className='squad-empty-description'>{DESCRIPTION}</P>
      <ButtonLink
        onClick={handleJoinNow}
        href={ROUTE_PATH.REGISTER}
        className='squad-empty-join-now'
      >
        {JOIN_NOW}
      </ButtonLink>
      <Link
        href={ROUTE_PATH.LOGIN}
        onClick={handleClickSignIn}
        className='squad-empty-sign-in'
      >
        {SIGN_IN}
      </Link>
      <SquadPageEmptyHowItWorks />
    </Flex>
  )
}
